import { insert } from 'ramda';
import { compose, withProps } from 'recompose';

import {
  SalesByBarber,
  SalesByBarberContainer,
  salesByBarberDefaultColumns,
  withDefaultSalesByBarberDataProvider,
} from '../SalesByBarberGeneric';

const locationColumn = {
  Header: 'Location',
  accessor: 'location',
  id: 'location',
};

export default compose(
  withProps(() => ({ 
    columns: insert(1, locationColumn, salesByBarberDefaultColumns()) // ✅ Call function at runtime
  })),
  withDefaultSalesByBarberDataProvider,
  SalesByBarberContainer,
)(SalesByBarber);
